import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// import { connect } from 'react-redux';
import classNames from 'classnames';

// import EndResultFines from './EndResultFines';
// import EndResultPules from './EndResultPules';
import {
  Row, Col, Button, Media, Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';

import { getBetValue } from '../../../../../../common/services/data-service';
import infoImg from '../../../../../../images/redesign/player/info.svg';
import CustomModal from '../../../Components/Components/Modal';
import PulesHelpInfo from './PulesHelpInfo';
import { renderNum } from '../../../../../../utils/stringUtils';

const ScoreTableSum = ({
  myPos, totalPnts, isEndResultTable, gameType, bet, t, pules, globalParams, players, showInfoModal, player1Pules, player2Pules, player3Pules, player4Pules, player1ShortName, player2ShortName, player3ShortName, player4ShortName,
}) => {
  const {
    minGames, gameState, fourPRoom, rPlayed, closeReason,
  } = globalParams;

  const [openPluesInfoModal, setOpenPluesInfoModal] = useState(false);
  const { i18n } = useTranslation();
  const lang = i18n.language || '';

  let betRatio;

  if (bet) {
    betRatio = parseInt(bet.replace('1:', ''), 10);
  }

  let betValue;
  let leavePenalty;
  let leaveReward;
  let penaltyPlayer;

  if (players && closeReason && closeReason.reason && (closeReason.reason === 'missedTurn' || closeReason.reason === 'leftRoom')) {
    betValue = getBetValue(bet);

    if (players.player1 && players.player1.uid === closeReason.playerUid) {
      penaltyPlayer = 'player1';
    } else if (players.player2 && players.player2.uid === closeReason.playerUid) {
      penaltyPlayer = 'player2';
    } else if (players.player3 && players.player3.uid === closeReason.playerUid) {
      penaltyPlayer = 'player3';
    } else if (players.player4 && players.player4.uid === closeReason.playerUid) {
      penaltyPlayer = 'player4';
    }

    if (closeReason.isAutomated) {
      leavePenalty = 0;
      leaveReward = 0;
    } else {
      leavePenalty = Math.round(betValue * 24);
      leaveReward = Math.round(0.25 * leavePenalty);
    }

    console.log('closeReason', { closeReason, minGames, rPlayed });

    if (closeReason.reason === 'leftRoom') {
      if (minGames && (rPlayed || rPlayed === 0) && minGames > (rPlayed) && betValue) {
        leavePenalty += Math.round((minGames - rPlayed) * 10 * betValue);

        leaveReward += Math.round(0.25 * (minGames - rPlayed) * 10 * betValue);
      }
    } else if (minGames && (rPlayed || rPlayed === 0) && minGames > rPlayed && betValue) {
      leavePenalty += Math.round((minGames - rPlayed) * 10 * betValue);

      leaveReward += Math.round(0.25 * (minGames - rPlayed) * 10 * betValue);
    }
  }

  return (
    <Row className="end-result-score-table-sum">
      <Col sm="12">
        <Row className="end-result-table-header-landscape">
          {/* <Col className="end-result-table-header-col">
            #
          </Col>
          {myPos === 'player1' && (
            <>
              <Col className="end-result-table-header-col">
                {player4ShortName}
              </Col>
              <Col className="end-result-table-header-col">
                {player1ShortName}
              </Col>
              <Col className="end-result-table-header-col">
                {player2ShortName}
              </Col>
              <Col className="end-result-table-header-col">
                {player3ShortName}
              </Col>
            </>
          )}
          {myPos === 'player2' && (
            <>
              <Col className="end-result-table-header-col">
                {player1ShortName}
              </Col>
              <Col className="end-result-table-header-col">
                {player2ShortName}
              </Col>
              <Col className="end-result-table-header-col">
                {player3ShortName}
              </Col>
              <Col className="end-result-table-header-col">
                {player4ShortName}
              </Col>
            </>
          )}
          {myPos === 'player3' && (
            <>
              <Col className="end-result-table-header-col">
                {player2ShortName}
              </Col>
              <Col className="end-result-table-header-col">
                {player3ShortName}
              </Col>
              <Col className="end-result-table-header-col">
                {player4ShortName}
              </Col>
              <Col className="end-result-table-header-col">
                {player1ShortName}
              </Col>
            </>
          )}
          {myPos === 'player4' && (
            <>
              <Col className="end-result-table-header-col">
                {player3ShortName}
              </Col>
              <Col className="end-result-table-header-col">
                {player4ShortName}
              </Col>
              <Col className="end-result-table-header-col">
                {player1ShortName}
              </Col>
              <Col className="end-result-table-header-col">
                {player2ShortName}
              </Col>
            </>
          )}
          <Col className="end-result-table-header-col">
            Pules
          </Col>
          <Col className="end-result-table-header-col" /> */}
        </Row>
        <Row className="end-result-table-header mt-3">
          <Col className="end-result-table-header-col">
            {t('game:points')}
          </Col>
          <Col className="end-result-table-header-col">
            <div className={classNames({
              'player-history-table-col-positive': (myPos === 'player1' && totalPnts && totalPnts.player4 > 0) || (myPos === 'player2' && totalPnts && totalPnts.player1 > 0) || (myPos === 'player3' && totalPnts && totalPnts.player2 > 0) || (myPos === 'player4' && totalPnts && totalPnts.player3 > 0),
              'player-history-table-col-negative': (myPos === 'player1' && totalPnts && totalPnts.player4 < 0) || (myPos === 'player2' && totalPnts && totalPnts.player1 < 0) || (myPos === 'player3' && totalPnts && totalPnts.player2 < 0) || (myPos === 'player4' && totalPnts && totalPnts.player3 < 0),
              'player-history-table-col-neutral': (myPos === 'player1' && totalPnts && totalPnts.player4 === 0) || (myPos === 'player2' && totalPnts && totalPnts.player1 === 0) || (myPos === 'player3' && totalPnts && totalPnts.player2 === 0) || (myPos === 'player4' && totalPnts && totalPnts.player3 === 0),
            })}
            >
              <>
                {myPos === 'player1' && (
                  <>{(totalPnts && totalPnts.player4 ? renderNum(totalPnts.player4) : 0)}</>
                )}
                {myPos === 'player2' && (
                  <>{(totalPnts && totalPnts.player1 ? renderNum(totalPnts.player1) : 0)}</>
                )}
                {myPos === 'player3' && (
                  <>{(totalPnts && totalPnts.player2 ? renderNum(totalPnts.player2) : 0)}</>
                )}
                {myPos === 'player4' && (
                  <>{(totalPnts && totalPnts.player3 ? renderNum(totalPnts.player3) : 0)}</>
                )}
              </>
            </div>
          </Col>
          <Col className="end-result-table-header-col">
            <div className={classNames({
              'player-history-table-col-positive': (myPos === 'player1' && totalPnts && totalPnts.player1 > 0) || (myPos === 'player2' && totalPnts && totalPnts.player2 > 0) || (myPos === 'player3' && totalPnts && totalPnts.player3 > 0) || (myPos === 'player4' && totalPnts && totalPnts.player4 > 0),
              'player-history-table-col-negative': (myPos === 'player1' && totalPnts && totalPnts.player1 < 0) || (myPos === 'player2' && totalPnts && totalPnts.player2 < 0) || (myPos === 'player3' && totalPnts && totalPnts.player3 < 0) || (myPos === 'player4' && totalPnts && totalPnts.player4 < 0),
              'player-history-table-col-neutral': (myPos === 'player1' && totalPnts && totalPnts.player1 === 0) || (myPos === 'player2' && totalPnts && totalPnts.player2 === 0) || (myPos === 'player3' && totalPnts && totalPnts.player3 === 0) || (myPos === 'player4' && totalPnts && totalPnts.player4 === 0),
            })}
            >
              <>
                {myPos === 'player1' && (
                  <>{(totalPnts && totalPnts.player1 ? renderNum(totalPnts.player1) : 0)}</>
                )}
                {myPos === 'player2' && (
                  <>{(totalPnts && totalPnts.player2 ? renderNum(totalPnts.player2) : 0)}</>
                )}
                {myPos === 'player3' && (
                  <>{(totalPnts && totalPnts.player3 ? renderNum(totalPnts.player3) : 0)}</>
                )}
                {myPos === 'player4' && (
                  <>{(totalPnts && totalPnts.player4 ? renderNum(totalPnts.player4) : 0)}</>
                )}
              </>
            </div>
          </Col>
          <Col className="end-result-table-header-col">
            <div className={classNames({
              'player-history-table-col-positive': (myPos === 'player1' && totalPnts && totalPnts.player2 > 0) || (myPos === 'player2' && totalPnts && totalPnts.player3 > 0) || (myPos === 'player3' && totalPnts && totalPnts.player4 > 0) || (myPos === 'player4' && totalPnts && totalPnts.player1 > 0),
              'player-history-table-col-negative': (myPos === 'player1' && totalPnts && totalPnts.player2 < 0) || (myPos === 'player2' && totalPnts && totalPnts.player3 < 0) || (myPos === 'player3' && totalPnts && totalPnts.player4 < 0) || (myPos === 'player4' && totalPnts && totalPnts.player1 < 0),
              'player-history-table-col-neutral': (myPos === 'player1' && totalPnts && totalPnts.player2 === 0) || (myPos === 'player2' && totalPnts && totalPnts.player3 === 0) || (myPos === 'player3' && totalPnts && totalPnts.player4 === 0) || (myPos === 'player4' && totalPnts && totalPnts.player1 === 0),
            })}
            >
              <>
                {myPos === 'player1' && (
                  <>{(totalPnts && totalPnts.player2 ? renderNum(totalPnts.player2) : 0)}</>
                )}
                {myPos === 'player2' && (
                  <>{(totalPnts && totalPnts.player3 ? renderNum(totalPnts.player3) : 0)}</>
                )}
                {myPos === 'player3' && (
                  <>{(totalPnts && totalPnts.player4 ? renderNum(totalPnts.player4) : 0)}</>
                )}
                {myPos === 'player4' && (
                  <>{(totalPnts && totalPnts.player1 ? renderNum(totalPnts.player1) : 0)}</>
                )}
              </>
            </div>
          </Col>
          <Col className="end-result-table-header-col">
            <div className={classNames({
              'player-history-table-col-positive': (myPos === 'player1' && totalPnts && totalPnts.player3 > 0) || (myPos === 'player2' && totalPnts && totalPnts.player4 > 0) || (myPos === 'player3' && totalPnts && totalPnts.player1 > 0) || (myPos === 'player4' && totalPnts && totalPnts.player2 > 0),
              'player-history-table-col-negative': (myPos === 'player1' && totalPnts && totalPnts.player3 < 0) || (myPos === 'player2' && totalPnts && totalPnts.player4 < 0) || (myPos === 'player3' && totalPnts && totalPnts.player1 < 0) || (myPos === 'player4' && totalPnts && totalPnts.player2 < 0),
              'player-history-table-col-neutral': (myPos === 'player1' && totalPnts && totalPnts.player3 === 0) || (myPos === 'player2' && totalPnts && totalPnts.player4 === 0) || (myPos === 'player3' && totalPnts && totalPnts.player1 === 0) || (myPos === 'player4' && totalPnts && totalPnts.player2 === 0),
            })}
            >
              <>
                {myPos === 'player1' && (
                  <>{(totalPnts && totalPnts.player3 ? renderNum(totalPnts.player3) : 0)}</>
                )}
                {myPos === 'player2' && (
                  <>{(totalPnts && totalPnts.player4 ? renderNum(totalPnts.player4) : 0)}</>
                )}
                {myPos === 'player3' && (
                  <>{(totalPnts && totalPnts.player1 ? renderNum(totalPnts.player1) : 0)}</>
                )}
                {myPos === 'player4' && (
                  <>{(totalPnts && totalPnts.player2 ? renderNum(totalPnts.player2) : 0)}</>
                )}
              </>
            </div>
          </Col>
          <Col className="end-result-table-header-col" />
        </Row>
        <Row className="end-result-table-header mt-3">
          <Col className="end-result-table-header-col">
            {t('game:zoles')}
          </Col>
          <Col className="end-result-table-header-col">
            <div className={classNames({
              'player-history-table-col-positive':
                (myPos === 'player1' && totalPnts && totalPnts.player4 && betRatio && betRatio * totalPnts.player4 > 0)
                || (myPos === 'player2' && totalPnts && totalPnts.player1 && betRatio && betRatio * totalPnts.player1 > 0)
                || (myPos === 'player3' && totalPnts && totalPnts.player2 && betRatio && betRatio * totalPnts.player2 > 0)
                || (myPos === 'player4' && totalPnts && totalPnts.player3 && betRatio && betRatio * totalPnts.player3 > 0),
              'player-history-table-col-negative':
                (myPos === 'player1' && totalPnts && totalPnts.player4 && betRatio && betRatio * totalPnts.player4 < 0)
                || (myPos === 'player2' && totalPnts && totalPnts.player1 && betRatio && betRatio * totalPnts.player1 < 0)
                || (myPos === 'player3' && totalPnts && totalPnts.player2 && betRatio && betRatio * totalPnts.player2 < 0)
                || (myPos === 'player4' && totalPnts && totalPnts.player3 && betRatio && betRatio * totalPnts.player3 < 0),
              'player-history-table-col-neutral':
                (myPos === 'player1' && ((totalPnts && totalPnts.player4 && betRatio && betRatio * totalPnts.player4 === 0) || !totalPnts?.player4))
                || (myPos === 'player2' && ((totalPnts && totalPnts.player1 && betRatio && betRatio * totalPnts.player1 === 0) || !totalPnts?.player1))
                || (myPos === 'player3' && ((totalPnts && totalPnts.player2 && betRatio && betRatio * totalPnts.player2 === 0) || !totalPnts?.player2))
                || (myPos === 'player4' && ((totalPnts && totalPnts.player3 && betRatio && betRatio * totalPnts.player3 === 0) || !totalPnts?.player3)),
            })}
            >
              <>
                {myPos === 'player1' && (
                  <>
                    {totalPnts && totalPnts.player4 && betRatio
                      ? renderNum(betRatio * totalPnts.player4)
                      : 0}
                  </>
                )}
                {myPos === 'player2' && (
                  <>
                    {totalPnts && totalPnts.player1 && betRatio
                      ? renderNum(betRatio * totalPnts.player1)
                      : 0}
                  </>
                )}
                {myPos === 'player3' && (
                  <>
                    {totalPnts && totalPnts.player2 && betRatio
                      ? renderNum(betRatio * totalPnts.player2)
                      : 0}
                  </>
                )}
                {myPos === 'player4' && (
                  <>
                    {totalPnts && totalPnts.player3 && betRatio
                      ? renderNum(betRatio * totalPnts.player3)
                      : 0}
                  </>
                )}
              </>
            </div>
          </Col>
          <Col className="end-result-table-header-col">
            <div className={classNames({
              'player-history-table-col-positive':
              (myPos === 'player1' && totalPnts && totalPnts.player1 && betRatio && betRatio * totalPnts.player1 > 0)
              || (myPos === 'player2' && totalPnts && totalPnts.player2 && betRatio && betRatio * totalPnts.player2 > 0)
              || (myPos === 'player3' && totalPnts && totalPnts.player13 && betRatio && betRatio * totalPnts.player3 > 0)
              || (myPos === 'player4' && totalPnts && totalPnts.player4 && betRatio && betRatio * totalPnts.player4 > 0),
              'player-history-table-col-negative':
              (myPos === 'player1' && totalPnts && totalPnts.player1 && betRatio && betRatio * totalPnts.player1 < 0)
              || (myPos === 'player2' && totalPnts && totalPnts.player2 && betRatio && betRatio * totalPnts.player2 <= 0)
              || (myPos === 'player3' && totalPnts && totalPnts.player3 && betRatio && betRatio * totalPnts.player3 < 0)
              || (myPos === 'player4' && totalPnts && totalPnts.player4 && betRatio && betRatio * totalPnts.player4 < 0),
              'player-history-table-col-neutral':
              (myPos === 'player1' && ((totalPnts && totalPnts.player1 && betRatio && betRatio * totalPnts.player1 === 0) || !totalPnts?.player1))
              || (myPos === 'player2' && ((totalPnts && totalPnts.player2 && betRatio && betRatio * totalPnts.player2 === 0) || !totalPnts?.player2))
              || (myPos === 'player3' && ((totalPnts && totalPnts.player3 && betRatio && betRatio * totalPnts.player3 === 0) || !totalPnts?.player3))
              || (myPos === 'player4' && ((totalPnts && totalPnts.player4 && betRatio && betRatio * totalPnts.player4 === 0) || !totalPnts?.player4)),
            })}
            >
              <>
                {myPos === 'player1' && (
                  <>
                    {totalPnts && totalPnts.player1 && betRatio
                      ? renderNum(betRatio * totalPnts.player1)
                      : 0}
                  </>
                )}
                {myPos === 'player2' && (
                  <>
                    {totalPnts && totalPnts.player2 && betRatio
                      ? renderNum(betRatio * totalPnts.player2)
                      : 0}
                  </>
                )}
                {myPos === 'player3' && (
                  <>
                    {totalPnts && totalPnts.player3 && betRatio
                      ? renderNum(betRatio * totalPnts.player3)
                      : 0}
                  </>
                )}
                {myPos === 'player4' && (
                  <>
                    {totalPnts && totalPnts.player4 && betRatio
                      ? renderNum(betRatio * totalPnts.player4)
                      : 0}
                  </>
                )}
              </>
            </div>
          </Col>
          <Col className="end-result-table-header-col">
            <div className={classNames({
              'player-history-table-col-positive':
                (myPos === 'player1' && totalPnts && totalPnts.player2 && betRatio && betRatio * totalPnts.player2 > 0)
                || (myPos === 'player2' && totalPnts && totalPnts.player3 && betRatio && betRatio * totalPnts.player3 > 0)
                || (myPos === 'player3' && totalPnts && totalPnts.player4 && betRatio && betRatio * totalPnts.player4 > 0)
                || (myPos === 'player4' && totalPnts && totalPnts.player1 && betRatio && betRatio * totalPnts.player1 > 0),
              'player-history-table-col-negative':
                (myPos === 'player1' && totalPnts && totalPnts.player2 && betRatio && betRatio * totalPnts.player2 < 0)
                || (myPos === 'player2' && totalPnts && totalPnts.player3 && betRatio && betRatio * totalPnts.player3 < 0)
                || (myPos === 'player3' && totalPnts && totalPnts.player4 && betRatio && betRatio * totalPnts.player4 < 0)
                || (myPos === 'player4' && totalPnts && totalPnts.player1 && betRatio && betRatio * totalPnts.player1 < 0),
              'player-history-table-col-neutral':
                (myPos === 'player1' && ((totalPnts && totalPnts.player2 && betRatio && betRatio * totalPnts.player2 === 0) || !totalPnts?.player2))
                || (myPos === 'player2' && ((totalPnts && totalPnts.player3 && betRatio && betRatio * totalPnts.player3 === 0) || !totalPnts?.player3))
                || (myPos === 'player3' && ((totalPnts && totalPnts.player4 && betRatio && betRatio * totalPnts.player4 === 0) || !totalPnts?.player4))
                || (myPos === 'player4' && ((totalPnts && totalPnts.player1 && betRatio && betRatio * totalPnts.player1 === 0) || !totalPnts?.player1)),
            })}
            >
              <>
                {myPos === 'player1' && (
                  <>
                    {totalPnts && totalPnts.player2 && betRatio
                      ? renderNum(betRatio * totalPnts.player2)
                      : 0}
                  </>
                )}
                {myPos === 'player2' && (
                  <>
                    {totalPnts && totalPnts.player3 && betRatio
                      ? renderNum(betRatio * totalPnts.player3)
                      : 0}
                  </>
                )}
                {myPos === 'player3' && (
                  <>
                    {totalPnts && totalPnts.player4 && betRatio
                      ? renderNum(betRatio * totalPnts.player4)
                      : 0}
                  </>
                )}
                {myPos === 'player4' && (
                  <>
                    {totalPnts && totalPnts.player1 && betRatio
                      ? renderNum(betRatio * totalPnts.player1)
                      : 0}
                  </>
                )}
              </>
            </div>
          </Col>
          <Col className="end-result-table-header-col">
            <div className={classNames({
              'player-history-table-col-positive':
                (myPos === 'player1' && totalPnts && totalPnts.player3 && betRatio && betRatio * totalPnts.player3 > 0)
                || (myPos === 'player2' && totalPnts && totalPnts.player4 && betRatio && betRatio * totalPnts.player4 > 0)
                || (myPos === 'player3' && totalPnts && totalPnts.player1 && betRatio && betRatio * totalPnts.player1 > 0)
                || (myPos === 'player4' && totalPnts && totalPnts.player2 && betRatio && betRatio * totalPnts.player2 > 0),
              'player-history-table-col-negative':
                (myPos === 'player1' && totalPnts && totalPnts.player3 && betRatio && betRatio * totalPnts.player3 < 0)
                || (myPos === 'player2' && totalPnts && totalPnts.player4 && betRatio && betRatio * totalPnts.player4 < 0)
                || (myPos === 'player3' && totalPnts && totalPnts.player1 && betRatio && betRatio * totalPnts.player1 < 0)
                || (myPos === 'player4' && totalPnts && totalPnts.player2 && betRatio && betRatio * totalPnts.player2 < 0),
              'player-history-table-col-neutral':
                (myPos === 'player1' && ((totalPnts && totalPnts.player3 && betRatio && betRatio * totalPnts.player3 === 0) || !totalPnts?.player3))
                || (myPos === 'player2' && ((totalPnts && totalPnts.player4 && betRatio && betRatio * totalPnts.player4 === 0) || !totalPnts?.player4))
                || (myPos === 'player3' && ((totalPnts && totalPnts.player1 && betRatio && betRatio * totalPnts.player1 === 0) || !totalPnts?.player1))
                || (myPos === 'player4' && ((totalPnts && totalPnts.player2 && betRatio && betRatio * totalPnts.player2 === 0) || !totalPnts?.player2)),
            })}
            >
              <>
                {myPos === 'player1' && (
                  <>
                    {totalPnts && totalPnts.player3 && betRatio
                      ? renderNum(betRatio * totalPnts.player3)
                      : 0}
                  </>
                )}
                {myPos === 'player2' && (
                  <>
                    {totalPnts && totalPnts.player4 && betRatio
                      ? renderNum(betRatio * totalPnts.player4)
                      : 0}
                  </>
                )}
                {myPos === 'player3' && (
                  <>
                    {totalPnts && totalPnts.player1 && betRatio
                      ? renderNum(betRatio * totalPnts.player1)
                      : 0}
                  </>
                )}
                {myPos === 'player4' && (
                  <>
                    {totalPnts && totalPnts.player2 && betRatio
                      ? renderNum(betRatio * totalPnts.player2)
                      : 0}
                  </>
                )}
              </>
            </div>
          </Col>
          <Col className="end-result-table-header-col" />
        </Row>
        {isEndResultTable && (
          <>
            {gameType && gameType.includes('P') && (
              <Row className="end-result-table-header mt-3">
                <Col className="end-result-table-header-col">
                  {t('game:pules')}
                </Col>
                <Col className="end-result-table-header-col">
                  <div className={classNames({
                    'player-history-table-col-positive': (myPos === 'player1' && player4Pules > 0) || (myPos === 'player2' && player1Pules > 0) || (myPos === 'player3' && player2Pules > 0) || (myPos === 'player4' && player3Pules > 0),
                    'player-history-table-col-negative': (myPos === 'player1' && player4Pules < 0) || (myPos === 'player2' && player1Pules < 0) || (myPos === 'player3' && player2Pules < 0) || (myPos === 'player4' && player3Pules < 0),
                    'player-history-table-col-neutral': (myPos === 'player1' && player4Pules === 0) || (myPos === 'player2' && player1Pules === 0) || (myPos === 'player3' && player2Pules === 0) || (myPos === 'player4' && player3Pules === 0),
                  })}
                  >
                    <>
                      {myPos === 'player1' && (
                        <>
                          {player4Pules}
                        </>
                      )}
                      {myPos === 'player2' && (
                        <>
                          {player1Pules}
                        </>
                      )}
                      {myPos === 'player3' && (
                        <>
                          {player2Pules}
                        </>
                      )}
                      {myPos === 'player4' && (
                        <>
                          {player3Pules}
                        </>
                      )}
                    </>
                  </div>
                </Col>
                <Col className="end-result-table-header-col">
                  <div className={classNames({
                    'player-history-table-col-positive': (myPos === 'player1' && player1Pules > 0) || (myPos === 'player2' && player2Pules > 0) || (myPos === 'player3' && player3Pules > 0) || (myPos === 'player4' && player4Pules > 0),
                    'player-history-table-col-negative': (myPos === 'player1' && player1Pules < 0) || (myPos === 'player2' && player2Pules < 0) || (myPos === 'player3' && player3Pules < 0) || (myPos === 'player4' && player4Pules < 0),
                    'player-history-table-col-neutral': (myPos === 'player1' && player1Pules === 0) || (myPos === 'player2' && player2Pules === 0) || (myPos === 'player3' && player3Pules === 0) || (myPos === 'player4' && player4Pules === 0),
                  })}
                  >
                    <>
                      {myPos === 'player1' && (
                        <>
                          {player1Pules}
                        </>
                      )}
                      {myPos === 'player2' && (
                        <>
                          {player2Pules}
                        </>
                      )}
                      {myPos === 'player3' && (
                        <>
                          {player3Pules}
                        </>
                      )}
                      {myPos === 'player4' && (
                        <>
                          {player4Pules}
                        </>
                      )}
                    </>
                  </div>
                </Col>
                <Col className="end-result-table-header-col">
                  <div className={classNames({
                    'player-history-table-col-positive': (myPos === 'player1' && player2Pules > 0) || (myPos === 'player2' && player3Pules > 0) || (myPos === 'player3' && player4Pules > 0) || (myPos === 'player4' && player1Pules > 0),
                    'player-history-table-col-negative': (myPos === 'player1' && player2Pules < 0) || (myPos === 'player2' && player3Pules < 0) || (myPos === 'player3' && player4Pules < 0) || (myPos === 'player4' && player1Pules < 0),
                    'player-history-table-col-neutral': (myPos === 'player1' && player2Pules === 0) || (myPos === 'player2' && player3Pules === 0) || (myPos === 'player3' && player4Pules === 0) || (myPos === 'player4' && player1Pules === 0),
                  })}
                  >
                    <>
                      {myPos === 'player1' && (
                        <>
                          {player2Pules}
                        </>
                      )}
                      {myPos === 'player2' && (
                        <>
                          {player3Pules}
                        </>
                      )}
                      {myPos === 'player3' && (
                        <>
                          {player4Pules}
                        </>
                      )}
                      {myPos === 'player4' && (
                        <>
                          {player1Pules}
                        </>
                      )}

                    </>
                  </div>
                </Col>
                <Col className="end-result-table-header-col">
                  <div className={classNames({
                    'player-history-table-col-positive': (myPos === 'player1' && player3Pules > 0) || (myPos === 'player2' && player4Pules > 0) || (myPos === 'player3' && player1Pules > 0) || (myPos === 'player4' && player2Pules > 0),
                    'player-history-table-col-negative': (myPos === 'player1' && player3Pules < 0) || (myPos === 'player2' && player4Pules < 0) || (myPos === 'player3' && player1Pules < 0) || (myPos === 'player4' && player2Pules < 0),
                    'player-history-table-col-neutral': (myPos === 'player1' && player3Pules === 0) || (myPos === 'player2' && player4Pules === 0) || (myPos === 'player3' && player1Pules === 0) || (myPos === 'player4' && player2Pules === 0),
                  })}
                  >
                    <>
                      {myPos === 'player1' && (
                        <>
                          {player3Pules}
                        </>
                      )}
                      {myPos === 'player2' && (
                        <>
                          {player4Pules}
                        </>
                      )}
                      {myPos === 'player3' && (
                        <>
                          {player1Pules}
                        </>
                      )}
                      {myPos === 'player4' && (
                        <>
                          {player2Pules}
                        </>
                      )}

                    </>
                  </div>
                </Col>
                <Col className="end-result-table-col end-result-table-col-last col">
                  <Media className="end-result-table-header-col-last-info-button" onClick={() => setOpenPluesInfoModal(!openPluesInfoModal)} src={infoImg} alt="x" />
                </Col>
              </Row>
            )}
            {closeReason && closeReason.reason && (closeReason.reason === 'missedTurn' || closeReason.reason === 'leftRoom') && (
              <Row className="end-result-table-header mt-3">
                <Col className="end-result-table-header-col">
                  {closeReason.reason === 'missedTurn' && (
                    t('game:missedTurnPenalty')
                  )}
                  {closeReason.reason === 'leftRoom' && (
                    t('game:leftRoomPenalty')
                  )}
                </Col>
                <Col className="end-result-table-header-col">
                  <div className={classNames({
                    'player-history-table-col-positive':
                      ((myPos === 'player1' && penaltyPlayer !== 'player4')
                      || (myPos === 'player2' && penaltyPlayer !== 'player1')
                      || (myPos === 'player3' && penaltyPlayer !== 'player2')
                      || (myPos === 'player4' && penaltyPlayer !== 'player3'))
                      && leaveReward > 0,
                    'player-history-table-col-negative':
                      ((myPos === 'player1' && penaltyPlayer === 'player4')
                      || (myPos === 'player2' && penaltyPlayer === 'player1')
                      || (myPos === 'player3' && penaltyPlayer === 'player2')
                      || (myPos === 'player4' && penaltyPlayer === 'player3'))
                      && leavePenalty > 0,
                    'player-history-table-col-neutral':
                      (((myPos === 'player1' && penaltyPlayer !== 'player4')
                      || (myPos === 'player2' && penaltyPlayer !== 'player1')
                      || (myPos === 'player3' && penaltyPlayer !== 'player2')
                      || (myPos === 'player4' && penaltyPlayer !== 'player3'))
                      && leaveReward === 0)
                      || (((myPos === 'player1' && penaltyPlayer === 'player4')
                      || (myPos === 'player2' && penaltyPlayer === 'player1')
                      || (myPos === 'player3' && penaltyPlayer === 'player2')
                      || (myPos === 'player4' && penaltyPlayer === 'player3'))
                      && leavePenalty === 0),
                  })}
                  >
                    <>
                      {myPos === 'player1' && (
                        <>
                            {penaltyPlayer === 'player4' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                      {myPos === 'player2' && (
                        <>
                            {penaltyPlayer === 'player1' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                      {myPos === 'player3' && (
                        <>
                            {penaltyPlayer === 'player2' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                      {myPos === 'player4' && (
                        <>
                            {penaltyPlayer === 'player3' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                    </>
                  </div>
                </Col>
                <Col className="end-result-table-header-col">
                  <div className={classNames({
                    'player-history-table-col-positive':
                      ((myPos === 'player1' && penaltyPlayer !== 'player1')
                      || (myPos === 'player2' && penaltyPlayer !== 'player2')
                      || (myPos === 'player3' && penaltyPlayer !== 'player3')
                      || (myPos === 'player4' && penaltyPlayer !== 'player4'))
                      && leaveReward > 0,
                    'player-history-table-col-negative':
                      ((myPos === 'player1' && penaltyPlayer === 'player1')
                      || (myPos === 'player2' && penaltyPlayer === 'player2')
                      || (myPos === 'player3' && penaltyPlayer === 'player3')
                      || (myPos === 'player4' && penaltyPlayer === 'player4'))
                      && leavePenalty > 0,
                    'player-history-table-col-neutral':
                      (((myPos === 'player1' && penaltyPlayer !== 'player1')
                      || (myPos === 'player2' && penaltyPlayer !== 'player2')
                      || (myPos === 'player3' && penaltyPlayer !== 'player3')
                      || (myPos === 'player4' && penaltyPlayer !== 'player4'))
                      && leaveReward === 0)
                      || (((myPos === 'player1' && penaltyPlayer === 'player1')
                      || (myPos === 'player2' && penaltyPlayer === 'player2')
                      || (myPos === 'player3' && penaltyPlayer === 'player3')
                      || (myPos === 'player4' && penaltyPlayer === 'player4'))
                      && leavePenalty === 0),
                  })}
                  >
                    <>
                      {myPos === 'player1' && (
                        <>
                            {penaltyPlayer === 'player1' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                      {myPos === 'player2' && (
                        <>
                            {penaltyPlayer === 'player2' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                      {myPos === 'player3' && (
                        <>
                            {penaltyPlayer === 'player3' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                      {myPos === 'player4' && (
                        <>
                            {penaltyPlayer === 'player4' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                    </>
                  </div>
                </Col>
                <Col className="end-result-table-header-col">
                  <div className={classNames({
                    'player-history-table-col-positive':
                      ((myPos === 'player1' && penaltyPlayer !== 'player2')
                      || (myPos === 'player2' && penaltyPlayer !== 'player3')
                      || (myPos === 'player3' && penaltyPlayer !== 'player4')
                      || (myPos === 'player4' && penaltyPlayer !== 'player1'))
                      && leaveReward > 0,
                    'player-history-table-col-negative':
                      ((myPos === 'player1' && penaltyPlayer === 'player2')
                      || (myPos === 'player2' && penaltyPlayer === 'player3')
                      || (myPos === 'player3' && penaltyPlayer === 'player4')
                      || (myPos === 'player4' && penaltyPlayer !== 'player1'))
                      && leavePenalty > 0,
                    'player-history-table-col-neutral':
                      (((myPos === 'player1' && penaltyPlayer !== 'player2')
                      || (myPos === 'player2' && penaltyPlayer !== 'player3')
                      || (myPos === 'player3' && penaltyPlayer !== 'player4')
                      || (myPos === 'player4' && penaltyPlayer !== 'player1'))
                      && leaveReward === 0)
                      || (((myPos === 'player1' && penaltyPlayer === 'player2')
                      || (myPos === 'player2' && penaltyPlayer === 'player3')
                      || (myPos === 'player3' && penaltyPlayer === 'player4')
                      || (myPos === 'player4' && penaltyPlayer === 'player1'))
                      && leavePenalty === 0),

                  })}
                  >
                    <>
                      {myPos === 'player1' && (
                        <>
                            {penaltyPlayer === 'player2' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                      {myPos === 'player2' && (
                        <>
                            {penaltyPlayer === 'player3' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                      {myPos === 'player3' && (
                        <>
                            {penaltyPlayer === 'player4' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                      {myPos === 'player4' && (
                        <>
                            {penaltyPlayer === 'player1' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                    </>
                  </div>
                </Col>
                <Col className="end-result-table-header-col">
                  <div className={classNames({
                    'player-history-table-col-positive':
                      ((myPos === 'player1' && penaltyPlayer !== 'player3')
                      || (myPos === 'player2' && penaltyPlayer !== 'player4')
                      || (myPos === 'player3' && penaltyPlayer !== 'player1')
                      || (myPos === 'player4' && penaltyPlayer !== 'player2'))
                      && leaveReward > 0,
                    'player-history-table-col-negative':
                      ((myPos === 'player1' && penaltyPlayer === 'player3')
                      || (myPos === 'player2' && penaltyPlayer === 'player4')
                      || (myPos === 'player3' && penaltyPlayer === 'player1')
                      || (myPos === 'player4' && penaltyPlayer === 'player2'))
                      && leavePenalty > 0,
                    'player-history-table-col-neutral':
                      (((myPos === 'player1' && penaltyPlayer !== 'player3')
                      || (myPos === 'player2' && penaltyPlayer !== 'player4')
                      || (myPos === 'player3' && penaltyPlayer !== 'player1')
                      || (myPos === 'player4' && penaltyPlayer !== 'player2'))
                      && leaveReward === 0)
                      || (((myPos === 'player1' && penaltyPlayer === 'player3')
                      || (myPos === 'player2' && penaltyPlayer === 'player4')
                      || (myPos === 'player3' && penaltyPlayer === 'player1')
                      || (myPos === 'player4' && penaltyPlayer === 'player2'))
                      && leavePenalty === 0),
                  })}
                  >
                    <>
                      {myPos === 'player1' && (
                        <>
                            {penaltyPlayer === 'player3' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                      {myPos === 'player2' && (
                        <>
                            {penaltyPlayer === 'player4' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                      {myPos === 'player3' && (
                        <>
                            {penaltyPlayer === 'player1' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                      {myPos === 'player4' && (
                        <>
                            {penaltyPlayer === 'player2' ? (renderNum(-leavePenalty)) : (renderNum(leaveReward))}
                        </>
                      )}
                    </>
                  </div>
                </Col>
                <Col className="end-result-table-header-col end-result-table-col-last">
                  <Media className="end-result-table-header-col-last-info-button" onClick={showInfoModal} src={infoImg} alt="x" />
                </Col>
              </Row>
            )}
          </>
        )}
      </Col>
      <CustomModal
        isOpen={openPluesInfoModal}
        toggle={() => setOpenPluesInfoModal(!openPluesInfoModal)}
        title={t('game:pulesDescription')}
        addClassName="gameinfo-modal"
        disableFlex
        footerClose
        footer={(
          <>
            <Button className="notification-footer-button" onClick={() => setOpenPluesInfoModal(!openPluesInfoModal)}>
              {t('game:ok')}
            </Button>
          </>
        )}
        body={(
          <div className="gameinfo-modal-content">
            <PulesHelpInfo lang={lang} />
          </div>
        )}
      />
    </Row>
  );
};

ScoreTableSum.propTypes = {
  totalPnts: PropTypes.shape(),
  myPos: PropTypes.string,
  isEndResultTable: PropTypes.bool,
  t: PropTypes.func.isRequired,
  showInfoModal: PropTypes.func.isRequired,
  player1Pules: PropTypes.number,
  player2Pules: PropTypes.number,
  player3Pules: PropTypes.number,
  player4Pules: PropTypes.number,
  globalParams: PropTypes.shape({}),
  players: PropTypes.shape({}),
};

ScoreTableSum.defaultProps = {
  totalPnts: {},
  myPos: '',
  isEndResultTable: false,
};


export default ScoreTableSum;
